module.exports = __webpack_public_path__ + "static/media/14UNEP21.cb852b0e.jpg";